export default Object.freeze({
  AUTO: 'auto',
  AUTO_CUSTOM_MAX: 'auto_custom_max',
  AUTO_FULL_WIDTH: 'auto_full_width',
  EXACT: 'exact'
});